import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { translate } from '../../utils/util';
import { SelectItem } from './ComponentsUI';
import useStateWithPromise from '../../utils/useEffectUpdate';
import RoutePickingService from '../../services/RoutePickingService';

const SelectRoute = (props) => {
    const [routes, setRoute] = useStateWithPromise([]);
    const [isLoading, setIsLoading] = useState(false);


    useEffect(() => {
        setIsLoading(true);
        props.getRoutes({ routeType: props.routeType }, (data) => {
            var drop = data.map((i) => {
                return { id: i.value, text: i.value };
            }).sort((a, b) => {
                if (a.text < b.text) { return -1; }
                if (a.text > b.text) { return 1; }
                return 0;
            });
            setIsLoading(false)
            setRoute(drop);
        });
        // eslint-disable-next-line
    }, []);


    const onChange = (event) => {
        if (props.onChange) {
            props.onChange(event);
        }
    }

    return (
        <SelectItem
            {...props}
            isLoading={isLoading}
            id={props.id || "route"}
            label={translate('mapping:route', 'line-picking')}
            placeHolder={translate('general:choose-one-option')}
            minLength={0}
            onChange={onChange}
            onChangeData={onChange}
            changeEvent="true"
            data={routes} />

    )
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getRoutes: (filter, callback) => {
            dispatch(RoutePickingService.getRouteDrop(callback));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SelectRoute));
